import * as Api from '@ViewModels';
import { computed, makeObservable, observable } from 'mobx';
import { ILeadServedOutcomeView } from './leads/interfaces';
/**
 * The view models in this file are just skins over the interfaces. They are used for various views like the Call Log
 * screen, Follow Ups, etc.
 */

export class RecentCallViewModel extends Api.ViewModel implements ILeadServedOutcomeView {
	public view: ILeadServedOutcomeView;
	constructor(userSession: Api.UserSessionContext, view: ILeadServedOutcomeView) {
		super(userSession);

		makeObservable(this, {
			view: observable,
			phoneCall: computed,
			interaction: computed,
			company: computed,
			contact: computed,
			lastDeal: computed,
			followUp: computed,
			nextMeeting: computed,
			creator: computed,
			id: computed,
		});

		this.view = view;
	}
	get phoneCall() {
		return this.view.phoneCall;
	}
	get interaction() {
		return this.view.interaction;
	}
	get company() {
		return this.view.company;
	}
	get contact() {
		return this.view.contact;
	}
	get lastDeal() {
		return this.view.lastDeal;
	}
	get followUp() {
		return this.view.followUp;
	}
	get nextMeeting() {
		return this.view.nextMeeting;
	}
	get creator() {
		return this.view.creator;
	}
	public get id() {
		// view.id is the leadserved so it is not enough to be unique

		return `${this.view.id}-${this.view.interaction.date}`;
	}
}

export enum LeadServedFilterCriteriaProperty {
	Category = 'Category',
	CompanyTag = 'CompanyTag',
	Date = 'Date',
	LeadCallMode = 'LeadCallMode',
	Manager = 'Manager',
	OfficeLocation = 'OfficeLocation',
	Outcome = 'Outcome',
	QuotaTeam = 'QuotaTeam',
	RecordingChannels = 'RecordingChannels',
	Team = 'Team',
	TranscriptionStatus = 'TranscriptionStatus',
	User = 'User',
	UserRole = 'UserRole',
	DealDemoPerformDate = 'DealDemoPerformDate',
	DealStage = 'DealStage',
	CallDuration = 'CallDuration',
	CallType = 'CallType',
	ColdDemo = 'ColdDemo',
}

export type ILeadServedFilterCriteria = Api.IFilterCriteria<LeadServedFilterCriteriaProperty>;

export type ILeadServedFilterRequest = ILeadServedFilterCriteria;
export class RecentCallsViewModel extends Api.ViewModel {
	public recentCalls: Api.FilteredPageCollectionController<
		ILeadServedOutcomeView,
		RecentCallViewModel,
		ILeadServedFilterRequest
	>;
	constructor(userSession: Api.UserSessionContext) {
		super(userSession);

		makeObservable(this, {
			recentCalls: observable,
			controller: computed,
		});

		this.recentCalls = new Api.FilteredPageCollectionController<
			ILeadServedOutcomeView,
			RecentCallViewModel,
			ILeadServedFilterRequest
		>({
			apiPath: this.composeApiUrl({ urlPath: 'LeadServed/filter' }),
			client: this.userSession.webServiceHelper,
			httpMethod: 'POST',
			transformer: x => new RecentCallViewModel(this.userSession, x),
		});
	}

	get controller() {
		return this.recentCalls;
	}
}
